import { useEffect, useState } from "react";
import { toast } from "sonner";
import { HardDrive, Unplug } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const REASONS = {
  scope: "Nella schermata Google devi spuntare la casella di accesso a Google Drive prima di cliccare Continua.",
  denied: "Accesso annullato o negato nella schermata Google.",
  refresh: "Google non ha restituito il permesso permanente: rimuovi l'accesso dell'app dal tuo account Google e riprova.",
  token: "Credenziali Google (Client ID/Secret) non valide sul server.",
};

export const DriveConnect = () => {
  const [st, setSt] = useState(null);
  const load = () => api.get("/drive/status").then((r) => setSt(r.data));
  useEffect(() => {
    load();
    const q = new URLSearchParams(window.location.search);
    const p = q.get("drive");
    if (p === "ok") toast.success("Google Drive collegato");
    if (p === "error") toast.error("Collegamento a Google Drive non riuscito", { description: REASONS[q.get("reason")] || REASONS.token, duration: 12000 });
    if (p) window.history.replaceState({}, "", window.location.pathname);
    const back = sessionStorage.getItem("drive_back");
    if (p && back && back !== window.location.pathname) { sessionStorage.removeItem("drive_back"); window.location.replace(`${back}?drive=${p}`); }
  }, []);
  const connect = async () => {
    sessionStorage.setItem("drive_back", window.location.pathname);
    try { const r = await api.get("/drive/connect", { params: { origin: window.location.origin } }); window.location.href = r.data.authorization_url; } catch (e) { toast.error(errMsg(e)); }
  };
  const disconnect = async () => {
    if (!window.confirm("Scollegare Google Drive? Non sarà più possibile caricare né vedere le foto finché non lo ricolleghi.")) return;
    await api.delete("/drive"); load();
  };
  if (!st) return null;
  return (
    <div className={`mb-4 flex flex-wrap items-center gap-3 rounded-xl border px-4 py-3 text-sm ${st.connected ? "border-emerald-200 bg-emerald-50" : "border-amber-200 bg-amber-50"}`} data-testid="drive-status">
      <HardDrive className={`h-5 w-5 ${st.connected ? "text-emerald-600" : "text-amber-600"}`} />
      <span className="flex-1 min-w-0">
        {st.connected
          ? <>Foto archiviate su Google Drive{st.email && <> di <b className="break-all">{st.email}</b></>} · cartella "FleetFuel - Sinistri"</>
          : st.expired
            ? <><b>Collegamento a Google Drive scaduto</b>{st.email && <> ({st.email})</>}: foto e allegati non si caricano finché non lo ricolleghi.</>
            : "Google Drive non collegato: foto e allegati non possono essere caricati."}
      </span>
      {st.connected
        ? <Button size="sm" variant="ghost" onClick={disconnect} data-testid="drive-disconnect-button"><Unplug className="mr-1 h-4 w-4" /> Scollega</Button>
        : <Button size="sm" onClick={connect} data-testid="drive-connect-button">{st.expired ? "Ricollega Google Drive" : "Collega Google Drive"}</Button>}
    </div>
  );
};
